import { Card, Text, View } from '@gluestack-ui/themed'
import React, { FunctionComponent } from 'react'
import { Image, StyleSheet, TouchableOpacity } from 'react-native'
import { ActualiteItemResult } from '../../../api/GridPage/types'
import { Routes } from '../../../navigation/Routes'
import { getItemAction } from '../../../services/itemAction'
import { theme } from '../../../theme'

interface CardLineProps {
  item: ActualiteItemResult
  height: number
}

const THUMBNAIL_SIZE = 80

export const CardLineItem: FunctionComponent<CardLineProps> = props => {
  const itemStyle = cardItemStyle(props.height)
  const { item } = props

  return (
    <TouchableOpacity
      style={itemStyle.content}
      onPress={getItemAction({
        type: 'view',
        viewName: Routes.Actualite,
        params: { id: item.id, titre: item.libelle, image: item.image },
      })}
    >
      <Card style={itemStyle.card}>
        <View style={itemStyle.cardItem}>
          <View style={itemStyle.body}>
            <View style={itemStyle.bodyContent}>
              <Text numberOfLines={2} style={itemStyle.titre}>
                {item.libelle}
              </Text>
              <Text style={itemStyle.note} numberOfLines={2}>
                {item.description}
              </Text>
            </View>
            <View style={itemStyle.bodyImage}>{item.image && <Image source={{ uri: item.image }} style={itemStyle.thumbnail} resizeMode="cover" />}</View>
          </View>
        </View>
      </Card>
    </TouchableOpacity>
  )
}

export const cardItemStyle = (height: number) =>
  /* eslint react-native/no-unused-styles: */
  StyleSheet.create({
    note: {
      opacity: 0.4,
    },
    content: {
      height,
      width: '100%',
      paddingBottom: theme.padding.x1,
    },
    card: {
      marginTop: 8,
      marginHorizontal: 4,
      marginBottom: 4,
      height: '100%',
    },
    cardItem: {
      padding: theme.padding.x1,
      flex: 1,
    },
    body: {
      flex: 1,
      flexDirection: 'row',
      alignItems: 'stretch',
    },
    bodyContent: {
      flex: 1,
      paddingRight: theme.padding.x1,
    },
    titre: {
      paddingBottom: theme.padding.x1,
    },
    bodyImage: {
      flex: 0,
    },
    thumbnail: {
      width: THUMBNAIL_SIZE,
      height: THUMBNAIL_SIZE,
    },
  })
